import ClassHelper from '../ClassHelper';

const RuleType = {
  PERCENT: '%',
  VALUE: ''
};

class RefundPoliceRule extends ClassHelper {
  constructor({ from, to, value } = {}) {
    super(...arguments);
    this.from = from;
    this.to = to;
    this.value = this.type === RuleType.PERCENT ? Number(value.replace('%', '')) : Number(value);
  }

  applyTo(amount) {
    let refundAmount = 0;

    if (typeof amount === 'string' && !isNaN(Number(amount))) {
      refundAmount = Number(amount);
    } else if(typeof amount === 'number') {
      refundAmount = amount;
    }

    return refundAmount;
  }

  getValue() {
    return this.value;
  }
}

export default RefundPoliceRule;